import axiosInstance from "../services/axiosInstance";

export const processLeaveApprovalToken = async ({
  token,
  action,
  leave_category,
}) => {
  try {
    const categoryQuery = leave_category
      ? `&leave_category=${encodeURIComponent(leave_category)}`
      : "";
    const response = await axiosInstance.get(
      `../approvals/leave?token=${encodeURIComponent(token)}&action=${encodeURIComponent(action)}${categoryQuery}`,
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 500,
        message: "An error occurred while processing leave approval.",
      }
    );
  }
};

export const processOvertimeApprovalToken = async ({ token, action }) => {
  try {
    const response = await axiosInstance.get(
      `../approvals/overtime?token=${encodeURIComponent(token)}&action=${encodeURIComponent(action)}`,
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 500,
        message: "An error occurred while processing overtime approval.",
      }
    );
  }
};

export const processScheduleApprovalToken = async ({ token, action }) => {
  try {
    const response = await axiosInstance.get(
      `../approvals/schedule?token=${encodeURIComponent(token)}&action=${encodeURIComponent(action)}`,
    );

    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: 500,
        message: "An error occurred while processing schedule approval.",
      }
    );
  }
};
